import MainPage from '@/pages/layout/MainPage';
import HomePage from '@/pages/HomePage';
import JizhanPage from '@/pages/jizhan/JiZhan';
import SheZhi from '@/pages/jizhan/SheZhi';
import XiangQing from '@/pages/jizhan/XiangQing';
import XiangQingIndex from '@/pages/jizhan/XiangQingIndex';
import DianChi from '@/pages/jizhan/DianChi';
import LoginPage from '@/pages/login/LoginPage';
import GuangFu from '@/pages/jizhan/guangfu/HomePage';
import DongHuan from '@/pages/jizhan/donghuan/HomePage';
import GaoJing from '@/pages/jizhan/GaoJing';
import DianYuan from '@/pages/jizhan/DianYuan';
import ChuNeng from '@/pages/jizhan/ChuNeng';
import store from '../store';
import { createRouter, createWebHashHistory } from 'vue-router';

const routes = [
    {
        path: '/', component: HomePage,
        children: [
            { path: "", component: MainPage },
            { path: '/jizhan', component: JizhanPage },
            { path: '/shezhi', component: SheZhi },
            {
                path: '/detail',
                component: XiangQing,
                children: [
                    { path: '', component: XiangQingIndex },
                    { path: 'dianchi', component: DianChi },
                    { path: 'guangfu', component: GuangFu },
                    { path: 'donghuan', component: DongHuan },
                    { path: 'gaojing', component: GaoJing },
                    { path: 'dianyuan', component: DianYuan },
                    { path: 'chuneng', component: ChuNeng },
                ]

            },
        ]
    },
    { name: 'Login', path: '/login', component: LoginPage },

]

const router = createRouter({
    // 4. 内部提供了 history 模式的实现。为了简单起见，我们在这里使用 hash 模式。
    history: createWebHashHistory(),
    routes, // `routes: routes` 的缩写
});



router.beforeEach((to, from, next) => {
    if (to.name !== 'Login' && !store.getters['User/token']) next({ name: 'Login' })
    else next()


    // ...
    // 返回 false 以取消导航
    // return false
})

export default router;